import { Loading } from '@components'
import { KEY_ACCESS, KEY_CODE, KEY_REFRESH } from '@constants'
import { getLocalStorage } from '@helpers'
import { getRefreshToken, getToken, redirectToLogin } from '@services'
import { createContext, useContext, useEffect, useState, type ReactNode } from 'react'
import { useLocation } from 'react-router-dom'

type SessionStatus = 'checking' | 'ready'

type SessionContextValue = {
  isSessionReady: boolean
}

const SessionContext = createContext<SessionContextValue>({ isSessionReady: false })

export const useSession = () => useContext(SessionContext)

type SessionProviderProps = {
  children: ReactNode
}

export const SessionProvider = ({ children }: SessionProviderProps) => {
  const [sessionStatus, setSessionStatus] = useState<SessionStatus>('checking')
  const location = useLocation()

  useEffect(() => {
    async function checkSession() {
      const keyCode = getLocalStorage(KEY_CODE)
      const keyAccess = getLocalStorage(KEY_ACCESS)
      const keyRefresh = getLocalStorage(KEY_REFRESH)
      const [, codeValue] = location.search.split('&code=')

      if (codeValue && keyCode !== codeValue) {
        const status = await getToken(codeValue)

        if (status === 'PASS') {
          window.location.replace('/')
        } else {
          console.error('ERROR GET NEW TOKEN => ', status)
        }

        return
      }

      if (!keyRefresh) {
        redirectToLogin()
        return
      }

      if (!keyAccess) {
        await getRefreshToken({})
      }

      setSessionStatus('ready')
    }

    checkSession()
  }, [location.search])

  if (sessionStatus === 'checking') {
    return <Loading />
  }

  return (
    <SessionContext.Provider value={{ isSessionReady: true }}>
      {children}
    </SessionContext.Provider>
  )
}
